import Link from "next/link";

interface LinkButtonProps {
  type: string,
  label?: string,
  labelColor?: string,
  href: any,
  className?: string,
  icon?: any,
  size?: string,
  active?: boolean
};

const LinkButton = ({
  active,
  type,
  label,
  href,
  className,
  size,
}: LinkButtonProps) => {
	let buttonClass;

	switch(type) {
    case "active":
      buttonClass = "bg-red bg-opacity-100 text-white";
      break;
		case "secondary":
			buttonClass = "bg-black bg-opacity-5 text-gray-900";
			break;
		case "tertiary":
			buttonClass = "bg-gray-100 text-black";
			break;
		case "danger":
			buttonClass = "bg-red text-white";
			break;
		default:
			buttonClass = "bg-black text-white";
	}

  switch(size) {
    case "sm":
      buttonClass += " h-8"
      break;
    default:
      buttonClass += " h-10"
  }

	return (
		<Link
      href={href}
      passHref
      style={{ transition: "all .15s ease" }}
      className={`transition-all p-3 text-base rounded-md flex justify-center items-center hover:shadow-lg cursor-pointer ${ className } ${ buttonClass }`}
		>
			{label}
		</Link>
	)
}

export default LinkButton;
